<script setup lang="ts">
import type { Icons } from '@/components/base/BaseIcon.vue'
import type { RadioCardOption } from '@/components/ui/AppRadioCard.vue'

import type { DistributionChannel } from '@/types/offer'

const { t } = useI18n()

const selectedChannels = defineModel<DistributionChannel[]>('selectedChannels', { required: true })

const channelConfig: { key: DistributionChannel; icon: Icons; labelKey: string }[] = [
  { key: 'in_store', icon: 'HeroBuildingOfficeIconOutline', labelKey: 'pages.offer.reward.channelInStore' },
  { key: 'kiosk', icon: 'HeroUsersIconOutline', labelKey: 'pages.offer.reward.channelKiosk' },
  {
    key: 'click_collect',
    icon: 'HeroDevicePhoneMobileIconOutline',
    labelKey: 'pages.offer.reward.channelClickCollect'
  },
  { key: 'online', icon: 'HeroGlobeAltIconOutline', labelKey: 'pages.offer.reward.channelOnline' },
  { key: 'delivery', icon: 'HeroTruckIconOutline', labelKey: 'pages.offer.reward.channelDelivery' }
]

type ChannelOption = RadioCardOption & { id: DistributionChannel }

const channelOptions = computed<ChannelOption[]>(() =>
  channelConfig.map((channel) => ({
    id: channel.key,
    title: t(channel.labelKey),
    icon: channel.icon
  }))
)

const selectedChannelOptions = computed({
  get: () => channelOptions.value.filter((option) => selectedChannels.value.includes(option.id)),
  set: (options: ChannelOption[]) => {
    selectedChannels.value = options.map((option) => option.id)
  }
})
</script>

<template>
  <Card>
    <CardHeader>
      <CardTitle>{{ t('pages.offer.reward.channelsTitle') }}</CardTitle>
      <CardDescription>{{ t('pages.offer.reward.channelsHint') }}</CardDescription>
    </CardHeader>
    <CardContent>
      <AppCheckboxCard
        v-model="selectedChannelOptions"
        :options="channelOptions"
        icon-as-radio
        class="grid-cols-1 sm:grid-cols-3"
      />
    </CardContent>
  </Card>
</template>
